import { Injectable } from '@angular/core';
import { BaseDataService } from './base.data.service';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IInspectionSiteSupplier } from '../interfaces/inspections/inspection-site-supplier';

@Injectable({
  providedIn: 'root',
})
export class InspectionSiteSupplierService extends BaseDataService {
  public url = '/api/inspectionSiteSuppliers';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public search(): Promise<IInspectionSiteSupplier[]> {
    return this.http.get<IInspectionSiteSupplier[]>(`${this.url}`).toPromise();
  }

  public deleteInspectionSiteSupplier(id: number) {
    return this.http.delete<any>(`${this.url}/${id}`).toPromise();
  }

  public updateInspectionSiteSupplier(dto: IInspectionSiteSupplier) {
    return this.http.put<any>(`${this.url}`, dto).toPromise();
  }

  public createInspectionSiteSupplier(dto: IInspectionSiteSupplier) {
    return this.http.post<any>(`${this.url}`, dto).toPromise();
  }
}
